import { Loading } from "@/components";
import { Outlet } from "@tanstack/react-router";

const LoadingCalendar = () => {
	return (
		<>
			<Outlet />
			<Loading status />
		</>
	);
};

export default LoadingCalendar;
